import type { ScheduleQuery } from "@myapp/contract";
import { normalizeFilters } from "../../../shared/lib/normalizeFilters";

export const scheduleKeys = {
  all: ["schedule"] as const,
  breaks: () => [...scheduleKeys.all, "breaks"] as const,
  workSession: () => [...scheduleKeys.all, "work-session"] as const,
  ranges: () => [...scheduleKeys.all, "range"] as const,
  /**
   * One key for both calendars. Omitting `technicianIds` is the all-technicians board, so the
   * normalized filters have to distinguish "no filter" from "this technician" — which they do,
   * since normalizeFilters drops undefined rather than coercing it.
   */
  range: (query: Partial<ScheduleQuery>) =>
    [...scheduleKeys.ranges(), normalizeFilters(query)] as const,
};
